<template>
    <div class="selector-wrapper" :class="imagetype">


        <card-landscape
            v-if="landscapemode"
            :options="$getAllObjects"
            :mapheight="imgHeight"
            :slidervisible="sliderVisible"
        ></card-landscape>

        <card-portrait
            v-if="!landscapemode"
            :options="$getAllObjects"
            :mapheight="imgHeightPort"
        ></card-portrait>




        <selector-list
            :mapheight="imgHeightList"
        />
    </div>
</template>

<script>
    import CardLandscape from '../components/CardLandscape.vue'
    import CardPortrait from '../components/CardPortrait.vue'
    import SelectorList from '../components/SelectorList.vue'

    export default {
        components: {
            CardLandscape,
            CardPortrait,
            SelectorList
        },

        props:{
            landscapemode: Boolean,
            imagetype: String,
            mapwidth: Number,
            mapheight: Number,

        },
        data(){
            return {
                imgHeight: '',
                imgHeightPort: '',
                imgHeightList:'',
                sliderVisible: false,
            }
        },

        created(){
            this.calcHeight()
            this.calcHeightPort()
            this.calcHeightList()
        },

        methods: {
            calcHeight() {
                const calc = this.mapwidth / 100;
                this.imgHeight = this.mapheight / calc
            },
            calcHeightPort() {
                if(window.innerWidth <= 768){
                    const calc = this.mapwidth / 100;
                    this.imgHeightPort = this.mapheight / calc
                }else {
                    const calc = this.mapwidth / 58;
                    this.imgHeightPort = this.mapheight / calc
                }
            },
            calcHeightList() {
                const calc = this.mapwidth / 100;
                this.imgHeightList = this.mapheight / calc
            },
            hideSlider(){
                this.sliderVisible = !this.sliderVisible
            }
        }


    }
</script>

<style>
    .selector-wrapper {
        position: fixed;
        top:120px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: auto;
    }

    @media (max-width: 768px) {
        .selector-wrapper {
           top: 72px;
        }
    }
</style>
